import { PixKeyType } from './key-type.enum';
import { PixPaymentFavored } from './payment-favored.model';
import { ETipoAgenteSaquetroco, ETipoOperacao } from './qr-code-return.model';
import { TipoIniciacaoTransferencia } from './tipo-iniciacao-transacao.enum';

export class PixPaymentFavoredView {
	sequencial: string;
	descricao: string;
	favorito: boolean;
	numeroAgencia: number;
	numeroConta: string;
	tipoConta: string;
	documento: string;
	iSPBCodigo: string;
	iSPBNome: string;
	nome: string;
	codigo: string;
	tipoChave: PixKeyType;
	codigoRequisicao: string;
	codigoFimAFim: string;
	valorTransferir: number;
	descricaoTransferir: string;
	dataTransferir: Date;
	toSave: boolean;
	tipoQrCode: string;
	valorQrCode: number;
	codigoTransacaoQrCode: string;
	informacaoAdicionalQrCode: string;
	tipoIniciacaoTransacao: TipoIniciacaoTransferencia;
	tipoOperacao?: ETipoOperacao;
	ispbServico?: string;
	tipoAgente?: ETipoAgenteSaquetroco;
	salvarFavorecido: boolean;
	constructor(model: PixPaymentFavored) {
		this.sequencial = model.sequencial;
		this.descricao = model.descricao;
		this.favorito = model.favorito;
		this.codigoFimAFim = model.codigoFimAFim;

		this.tipoQrCode = model.tipo;
		this.valorQrCode = model.valor;
		this.codigoTransacaoQrCode = model.codigoTransacao;
		this.informacaoAdicionalQrCode = model.informacaoAdicional;

		if(model.qrCodeEstatico){
			this.tipoOperacao = model.qrCodeEstatico.tipoOperacao;
			this.ispbServico = model.qrCodeEstatico.ispbServico;
			this.tipoAgente = model.qrCodeEstatico.tipoAgente;
		}

		if (model.conta) {
			this.numeroConta = model.conta.numeroConta;
			this.tipoConta = model.conta.tipoConta;
			this.numeroAgencia = model.conta.numeroAgencia;
			this.documento = model.conta.documento;
			this.iSPBCodigo = model.conta.iSPBCodigo;
			this.iSPBNome = model.conta.iSPBNome;
			this.nome = model.conta.nome;
		}

		if (model.chavePix) {
			this.codigo = model.chavePix.codigo;
			this.tipoChave = model.chavePix.tipoChave;
		}

		if (model.chave) {
			this.codigo = model.chave.codigo;
			this.tipoChave = model.chave.tipoChave;
			this.codigoRequisicao = model.chave.codigoRequisicao;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/payment-favored-view.model.ts